/* =========================================================
   CAPITAL THEME – INITIALS FIELD (MUTATION-SAFE VERSION)
   ========================================================= */

// let userCustomizationChoice = null;

// /* Core visibility logic */
// function applyInitialsVisibility() {
//   const wrapper = document.getElementById('custom-initials-wrapper');
//   const input = document.getElementById('custom-initials');
//   if (!wrapper || !input) return;

//   if (userCustomizationChoice === 'Customized') {
//     wrapper.style.display = 'block';
//   } else {
//     wrapper.style.display = 'none';
//     input.value = '';
//   }
// }

// /* Detect USER click on Customization only */
// document.addEventListener('click', function (e) {
//   const radio = e.target.closest('input[data-product-variant]');
//   if (!radio) return;

//   // ONLY option-1 (Customization)
//   if (!radio.name.includes('option-1')) return;

//   userCustomizationChoice = radio.value;
//   applyInitialsVisibility();
// });

// /* Initial state on page load (variant URL safe) */
// function setInitialCustomizationState() {
//   const checked = document.querySelector(
//     'input[data-product-variant][name*="option-1"]:checked'
//   );

//   userCustomizationChoice = checked ? checked.value : 'No Customization';
//   applyInitialsVisibility();
// }

// document.addEventListener('DOMContentLoaded', setInitialCustomizationState);

// /* WATCH FOR CAPITAL DOM REBUILDS */
// const observer = new MutationObserver(function () {
//   // Capital rebuilt swatches → re-apply visibility
//   applyInitialsVisibility();
// });

// document.addEventListener('DOMContentLoaded', function () {
//   const swatchContainer = document.querySelector('[data-product-options]');
//   if (!swatchContainer) return;

//   observer.observe(swatchContainer, {
//     childList: true,
//     subtree: true
//   });
// });

// /* Inject property into cart form */
// document.addEventListener('submit', function (e) {
//   const form = e.target;
//   if (!form.matches('form[action="/cart/add"]')) return;

//   const input = document.getElementById('custom-initials');
//   if (!input) return;

//   const value = input.value.trim();

//   const existing = form.querySelector('input[name="properties[Initials]"]');
//   if (existing) existing.remove();

//   if (userCustomizationChoice === 'Customized' && value !== '') {
//     const hidden = document.createElement('input');
//     hidden.type = 'hidden';
//     hidden.name = 'properties[Initials]';
//     hidden.value = value;
//     form.appendChild(hidden);
//   }
// });


//  2md version

/* =========================================================
   CAPITAL THEME – INITIALS FIELD (MUTATION-SAFE)
   ========================================================= */

// let userCustomizationChoice = null;

// /* Core visibility logic */
// function applyInitialsVisibility() {
//   const wrapper = document.getElementById('custom-initials-wrapper');
//   const input = document.getElementById('custom-initials');
//   if (!wrapper || !input) return;

//   if (userCustomizationChoice === 'Customized') {
//     wrapper.style.display = 'block';
//   } else {
//     wrapper.style.display = 'none';
//     input.value = '';
//   }
// }

// /* Auto-uppercase + max 3 chars */
// const initialsInput = document.getElementById('custom-initials');
// if (initialsInput) {
//   initialsInput.addEventListener('input', function () {
//     this.value = this.value.toUpperCase().slice(0, 3);
//   });
// }

// /* Detect USER click on Customization only */
// document.addEventListener('click', function (e) {
//   const radio = e.target.closest('input[data-product-variant]');
//   if (!radio) return;

//   // ONLY option-1 (Customization)
//   if (!radio.name.includes('option-1')) return;

//   userCustomizationChoice = radio.value;
//   applyInitialsVisibility();
// });

// /* Initial state on page load (variant URL safe) */
// function setInitialCustomizationState() {
//   const checked = document.querySelector(
//     'input[data-product-variant][name*="option-1"]:checked'
//   );

//   userCustomizationChoice = checked ? checked.value : 'No Customization';
//   applyInitialsVisibility();
// }

// document.addEventListener('DOMContentLoaded', setInitialCustomizationState);

// /* WATCH FOR CAPITAL DOM REBUILDS */
// const observer = new MutationObserver(function () {
//   // Capital rebuilt swatches → re-apply visibility
//   const checked = document.querySelector(
//     'input[data-product-variant][name*="option-1"]:checked'
//   );
//   userCustomizationChoice = checked ? checked.value : 'No Customization';
//   applyInitialsVisibility();
// });

// document.addEventListener('DOMContentLoaded', function () {
//   const swatchContainer = document.querySelector('[data-product-options]');
//   if (!swatchContainer) return;

//   observer.observe(swatchContainer, {
//     childList: true,
//     subtree: true
//   });
// });

// /* Inject property into cart form */
// document.addEventListener('submit', function (e) {
//   const form = e.target;
//   if (!form.matches('form[action="/cart/add"]')) return;

//   const input = document.getElementById('custom-initials');
//   if (!input) return;

//   const value = input.value.trim();

//   // Remove any existing property to prevent duplicates
//   const existing = form.querySelector('input[name="properties[Initials]"]');
//   if (existing) existing.remove();

//   // Add property if Customized and value not empty
//   if (userCustomizationChoice === 'Customized' && value !== '') {
//     const hidden = document.createElement('input');
//     hidden.type = 'hidden';
//     hidden.name = 'properties[Initials]';
//     hidden.value = value;
//     form.appendChild(hidden);
//   }
// });

// 3rd version

// let userCustomizationChoice = null;

// /* Core visibility logic */
// function applyInitialsVisibility() {
//   const wrapper = document.getElementById('custom-initials-wrapper');
//   const input = document.getElementById('custom-initials');
//   if (!wrapper || !input) return;

//   if (userCustomizationChoice === 'Customized') {
//     wrapper.style.display = 'block';
//   } else {
//     wrapper.style.display = 'none';
//     input.value = '';

//     // Clear hidden input in form
//     const form = document.querySelector('form[action="/cart/add"]');
//     if (form) {
//       const hidden = form.querySelector('input[name="properties[Initials]"]');
//       if (hidden) hidden.value = '';
//     }
//   }
// }

// /* Ensure hidden input exists inside the Add to Cart form */
// function ensureHiddenInput() {
//   const form = document.querySelector('form[action="/cart/add"]');
//   if (!form) return null;

//   let hidden = form.querySelector('input[name="properties[Initials]"]');
//   if (!hidden) {
//     hidden = document.createElement('input');
//     hidden.type = 'hidden';
//     hidden.name = 'properties[Initials]';
//     form.appendChild(hidden);
//   }
//   return hidden;
// }

// /* Detect user click on Customization variant */
// document.addEventListener('click', function (e) {
//   const radio = e.target.closest('input[data-product-variant]');
//   if (!radio) return;
//   if (!radio.name.includes('option-1')) return;

//   userCustomizationChoice = radio.value;
//   applyInitialsVisibility();
// });

// /* Initial state on page load */
// function setIni
//   userCustomizationChoice = checked ? checked.value : 'No Customization';
//   applyInitialsVisibility();

//   // Create hidden input immediately
//   ensureHiddenInput();
// }
// document.addEventListener('DOMContentLoaded', setInitialCustomizationState);

// /* Watch for Capital theme DOM rebuilds */
// const swatchContainer = document.querySelector('[data-product-options]');
// if (swatchContainer) {
//   const observer = new MutationObserver(() => {
//     const checked = swatchContainer.querySelector(
//       'input[data-product-variant][name*="option-1"]:checked'
//     );
//     userCustomizationChoice = checked ? checked.value : 'No Customization';
//     applyInitialsVisibility();
//   });
//   observer.observe(swatchContainer, { childList: true, subtree: true });
// }

// document.addEventListener('DOMContentLoaded', () => {
//   const visibleInput = document.getElementById('custom-initials');
//   const hiddenInput = document.getElementById('custom_initial_hidden');

//   if (!visibleInput || !hiddenInput) return;

//   visibleInput.addEventListener('input', function () {
//     hiddenInput.value = this.value;
//   });
// });
// tialCustomizationState() {
//   const checked = document.querySelector(
//     'input[data-product-variant][name*="option-1"]:checked'
//   );
//   userCustomizationChoice = checked ? checked.value : 'No Customization';
//   applyInitialsVisibility();

//   // Create hidden input immediately
//   ensureHiddenInput();
// }
// document.addEventListener('DOMContentLoaded', setInitialCustomizationState);

// /* Watch for Capital theme DOM rebuilds */
// const swatchContainer = document.querySelector('[data-product-options]');
// if (swatchContainer) {
//   const observer = new MutationObserver(() => {
//     const checked = swatchContainer.querySelector(
//       'input[data-product-variant][name*="option-1"]:checked'
//     );
//     userCustomizationChoice = checked ? checked.value : 'No Customization';
//     applyInitialsVisibility();
//   });
//   observer.observe(swatchContainer, { childList: true, subtree: true });
// }

// document.addEventListener('DOMContentLoaded', () => {
//   const visibleInput = document.getElementById('custom-initials');
//   const hiddenInput = document.getElementById('custom_initial_hidden');

//   if (!visibleInput || !hiddenInput) return;

//   visibleInput.addEventListener('input', function () {
//     hiddenInput.value = this.value;
//   });
// });

let userCustomizationChoice = null;

/* Core visibility logic */
function applyInitialsVisibility() {
  const wrapper = document.getElementById('custom-initials-wrapper');
  const visibleInput = document.getElementById('custom-initials');
  const hiddenInput = document.querySelector('form[action="/cart/add"] input[name="properties[Initials]"]');

  if (!wrapper || !visibleInput || !hiddenInput) return;

  if (userCustomizationChoice === 'Customized') {
    wrapper.style.display = 'block';

    // RESTORE value after DOM rebuild
    if (visibleInput.value === '' && hiddenInput.value !== '') {
      visibleInput.value = hiddenInput.value;
    }
  } else {
    wrapper.style.display = 'none';
    
    // Clear both when customization is OFF
    visibleInput.value = '';
    hiddenInput.value = '';
  }
}

/* Variant click (Capital theme rebuild trigger) */
document.addEventListener('click', function (e) {
  const radio = e.target.closest('input[data-product-variant]');
  if (!radio || !radio.name.includes('option-1')) return;

  userCustomizationChoice = radio.value;

  // Wait for theme HTML update
  setTimeout(applyInitialsVisibility, 0);
});

/* Initial state on page load */
document.addEventListener('DOMContentLoaded', function () {
  const checked = document.querySelector('input[data-product-variant][name*="option-1"]:checked');

  userCustomizationChoice = checked ? checked.value : 'No Customization';
  applyInitialsVisibility();
});

/* Watch for Capital theme DOM rebuilds */
document.addEventListener('DOMContentLoaded', function () {
  const swatchContainer = document.querySelector('[data-product-options]');
  if (!swatchContainer) return;

  const observer = new MutationObserver(() => {
    const checked = swatchContainer.querySelector('input[data-product-variant][name*="option-1"]:checked');

    userCustomizationChoice = checked ? checked.value : 'No Customization';
    applyInitialsVisibility();
  });

  observer.observe(swatchContainer, { childList: true, subtree: true });
});

/* Delegated input sync (visible → hidden) */
document.addEventListener('input', function (e) {
  if (e.target && e.target.id === 'custom-initials') {
    const hiddenInput = document.querySelector('form[action="/cart/add"] input[name="properties[Initials]"]');

    if (hiddenInput) {
      hiddenInput.value = e.target.value;
    }
  }
});

if ($(window).width() <= 767) {
  $('.visual-navigation__list').slick({
    infinite: false,
    slidesToShow: 2.5,
    arrows: false,
    prevArrow: '<button class="slick-prev custom-prev"><svg width="20" height="20" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg></button>',
    nextArrow: '<button class="slick-next custom-next"><svg width="20" height="20" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg></button>',
    responsive: [{
      breakpoint: 480,
      settings: {
        slidesToShow: 1.5
      }
    }]
  });
}